import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import Section from '../shared/Section/Section';
import Container from '../shared/Container/Container';
import './Problem.css';

const Problem = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <Section background="light">
      <Container>
        <div className="problem" ref={ref}>
          <motion.h2
            className="problem__title"
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            Regular Sauce Cups Leave Ribs Half-Dry
          </motion.h2>

          <motion.p
            className="problem__description"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Traditional tiny, round sauce cups were designed for nuggets — not full-size BBQ ribs. The ends get sauced while the middle stays dry. Our custom elongated Rib-n-Dip sauce cups solve this problem forever.
          </motion.p>

          <div className="problem__images">
            <motion.div
              className="problem__image problem__image--old"
              initial={{ opacity: 0, x: -30 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <div className="problem__image-wrapper">
                <div className="problem__image-badge problem__image-badge--old">
                  OLD WAY
                </div>
                {/* Image: traditional_cup.jpg */}
                {/* Prompt: Dull grayscale photo of someone struggling to dip a large rib into a tiny round sauce cup, sauce spilling, frustrating experience. */}
                <img
                  src="/images/traditional_cup.jpg"
                  alt="Traditional small round sauce cup inadequate for dipping full-size BBQ ribs"
                  className="problem__image-main problem__image-main--grayscale"
                  loading="lazy"
                />
                <p className="problem__image-caption">Messy, shallow, and wasteful.</p>
              </div>
            </motion.div>

            <motion.div
              className="problem__image problem__image--new"
              initial={{ opacity: 0, x: 30 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              <div className="problem__image-wrapper">
                <div className="problem__image-badge problem__image-badge--new">
                  NEW WAY
                </div>
                {/* Image: traditional_vs_ribndip.jpg */}
                {/* Prompt: Vibrant color photo showing a rib fitting perfectly into a rib-shaped cup, clean and satisfying, full sauce coverage. */}
                <img
                  src="/images/restaurant_tray_takeout.jpg"
                  alt="Rib-n-Dip elongated sauce cup perfect fit for full-size BBQ ribs with complete sauce coverage"
                  className="problem__image-main"
                  loading="lazy"
                />
                <p className="problem__image-caption">Rib-n-Dip cradles your rib perfectly for a clean, even dunk.</p>
              </div>
            </motion.div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default Problem;
